import * as React from 'react'

export const StrikeIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_strike)'>
        <path
          d='M4.58582 22.2178L5.60816 19.6505C7.68191 20.6106 9.50911 21.0907 11.0897 21.0907C12.3804 21.0907 13.4245 20.7568 14.2221 20.0889C15.0197 19.407 15.4185 18.5234 15.4185 17.4381C15.4185 16.4919 15.1429 15.7892 14.5919 15.3301C14.092 14.8893 12.9879 14.3458 11.2795 13.6997H-0.214172V11.1997H23.7858V13.6997H17.7628C18.5782 14.6016 18.9858 15.7713 18.9858 17.2085C18.9858 19.2957 18.1665 20.9307 16.5278 22.1135C15.0631 23.171 13.236 23.6997 11.0463 23.6997C8.91456 23.6997 6.76108 23.2057 4.58582 22.2178ZM10.6026 9.94969H5.36707C4.90425 9.16871 4.67283 8.26967 4.67283 7.25256C4.67283 5.34631 5.44865 3.8157 7.00029 2.66074C8.31996 1.68672 10.0167 1.19971 12.0904 1.19971C14.2075 1.19971 16.3538 1.73543 18.529 2.80687L17.5067 5.3741C15.8825 4.33051 14.1786 3.80871 12.3949 3.80871C11.0898 3.80871 10.0674 4.09397 9.32781 4.66447C8.60275 5.22104 8.24022 5.9933 8.24022 6.98127C8.24022 7.85791 8.5375 8.55363 9.13206 9.06844C9.44425 9.33152 9.93443 9.62527 10.6026 9.94969Z'
          fillRule='evenodd'
          clipRule='evenodd'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_strike'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
})

StrikeIcon.displayName = 'StrikeIcon'
